<template>
  <div class="head-box" id="header" >
    <!-- <div class="xdsdf" :style="{top: innerHeight+ 'px'}">
      <div class="kefudiv" @click="kefuhrefwai"></div>
    </div> -->
    <img class="xdssdddf" :style="{top: innerHeight+ 'px'}" src="../assets/images/dasdfas.png" @click="kefuhrefwai" alt="" />
    <img class="xdssdddf" :style="{top: innerHeight2+ 'px'}" src="../assets/images/dfsfrh.png" @click="sfsfft()" alt="" />

    <div class="logo">
      <router-link to="/" ><img src="../assets/images/logo.png" alt="" style="" @click="isActive = false"></router-link>
    </div>
    <ul class="menu" >
      <li class="li " v-on:mouseover="isnewShow = true" v-on:mouseout="isnewShow = false">
        <span   :class="{'activeLi':bigindexVal===1}" >{{$t('m.aboutsas')}}</span>
        <!-- <transition name = "fade"> -->
          <ul class="sonUl" v-show="isnewShow" v-on:mouseover="isnewShow = true" v-on:mouseout="isnewShow = false" >
            <li :class="{'activeLi':indexVal===1}" class="sonli" @click="hrefGoods('situation',1,1)">{{$t('m.aboutbpt')}}</li>
            <li :class="{'activeLi':indexVal===2}" class="sonli" @click="hrefGoods('legalDocument',1,2)">{{$t('m.adsboutbpt')}}</li>
            <!-- <li :class="{'activeLi':indexVal===2}"  class="sonli" >{{$t('m.adsboutbpt')}}</li> -->
            <li class="sonli" :class="{'activeLi':indexVal===3}"  @click="hrefGoods('companyAnnouncement',1,3)">{{$t('m.Companynotice')}}</li>
            <li class="sonli" :class="{'activeLi':indexVal===4}"  @click="hrefGoods('whyBpt',1,4)">Why BP Markets</li>
          </ul>
        <!-- </transition> -->
      </li>
      <li class="li" v-on:mouseover="isnewShow2 = true" v-on:mouseout="isnewShow2 = false">
        <span  :class="{'activeLi':bigindexVal===2}">{{$t('m.drrtpt')}}</span>
        <!-- <transition name = "fade"> -->
          <ul class="sonUl" v-show="isnewShow2" v-on:mouseover="isnewShow2 = true" v-on:mouseout="isnewShow2 = false">
            <li class="sonli" :class="{'activeLi':indexVal===5}" @click="hrefGoods('marketScope',1,5)">{{$t('m.drrtptssd')}}</li>
            <li class="sonli" :class="{'activeLi':indexVal===6}" @click="hrefGoods('foreignExchange',1,6)">{{$t('m.Forex')}}</li>
            <li class="sonli" :class="{'activeLi':indexVal===7}" @click="hrefGoods('commodities',1,7)">{{$t('m.dseerrtptssd')}}</li>
            <li class="sonli" :class="{'activeLi':indexVal===8}" @click="hrefGoods('exponent',1,8)">{{$t('m.Index')}}</li>
            <li class="sonli" :class="{'activeLi':indexVal===9}" @click="hrefGoods('digitalCurrency',1,9)">{{$t('m.deerptssd')}}</li>
          </ul>
        <!-- </transition> -->
      </li>

      <li class="li" v-on:mouseover="isnewShow3 = true" v-on:mouseout="isnewShow3 = false">
        <span  :class="{'activeLi':bigindexVal===3}" >{{$t('m.dssdeerptssd')}}</span>
        <!-- <transition name = "fade"> -->
          <ul class="sonUl" v-show="isnewShow3" v-on:mouseover="isnewShow3 = true" v-on:mouseout="isnewShow3 = false">
            <li class="sonli" @click="hrefGoods('cooperation',1,10)" :class="{'activeLi':indexVal===10}">{{$t('m.dssdeerptssd')}}</li>
          </ul> 
        <!-- </transition> -->
      </li>
     
      <li class="li" v-on:mouseover="isnewShow4 = true" v-on:mouseout="isnewShow4 = false" >
        <span  :class="{'activeLi':bigindexVal===4}">{{$t('m.rtrjkd')}}</span>
          <ul class="sonUl" v-show="isnewShow4" v-on:mouseover="isnewShow4 = true" v-on:mouseout="isnewShow4 = false">
            <li class="sonli" @click="hrefGoods('helpCenter',1,11)" :class="{'activeLi':indexVal===11}">{{$t('m.rtrjkdsf')}}</li>
            <li class="sonli" @click="hrefGoods('downloadGuide',1,17)" :class="{'activeLi':indexVal===17}">{{$t('m.dmiooefgse')}}</li>
          </ul>
      </li>
      <li class="li" v-on:mouseover="isnewShow5 = true" v-on:mouseout="isnewShow5 = false" >
        <span :class="{'activeLi':bigindexVal===5}">{{$t('m.wrraqwfsqgse')}}</span>
          <ul class="sonUl" v-show="isnewShow5" v-on:mouseover="isnewShow5 = true" v-on:mouseout="isnewShow5 = false">
            <li @click="hrefGoods('foreignExchangeTrading',1,12)" :class="{'activeLi':indexVal===12}" class="sonli" >{{$t('m.rssstrjkdsf')}}</li>
            <li @click="hrefGoods('contractDifference',1,13)" :class="{'activeLi':indexVal===13}" class="sonli" >{{$t('m.rssqqstrjkdsf')}}</li>
            <!-- <li @click="hrefGoods('newsInformation',1,14)" :class="{'activeLi':indexVal===14}" class="sonli" >{{$t('m.News')}}</li>
            <li class="sonli" @click="hrefGoods('economicCalendar',1,15)" :class="{'activeLi':indexVal===15}">{{$t('m.EconomicCalendar')}}</li>
            <li class="sonli" @click="hrefGoods('financialNews',1,16)" :class="{'activeLi':indexVal===16}">{{$t('m.swrgsqbr')}}</li> -->
          </ul>
      </li>
      <li class="li" v-on:mouseover="isnewShow6 = true" v-on:mouseout="isnewShow6 = false" >
        <span :class="{'activeLi':bigindexVal===6}">{{$t('m.wrraqwfsqgsqse')}}</span>
          <ul class="sonUl" v-show="isnewShow6" v-on:mouseover="isnewShow6 = true" v-on:mouseout="isnewShow6 = false">
            <li @click="hrefGoods('newsInformation',1,14)" :class="{'activeLi':indexVal===14}" class="sonli" >{{$t('m.News')}}</li>
            <li class="sonli" @click="hrefGoods('economicCalendar',1,15)" :class="{'activeLi':indexVal===15}">{{$t('m.EconomicCalendar')}}</li>
            <li class="sonli" @click="hrefGoods('financialNews',1,16)" :class="{'activeLi':indexVal===16}">{{$t('m.swrgsqbr')}}</li>
          </ul>
      </li>
    </ul>
    <ul class="RegisterBox">
      <li style="margin-right:30px" @click="signinhrefwai">{{$t('m.Login')}}</li>
      <li style="margin-right:30px" @click="signuphrefwai">{{$t('m.Register')}}</li>
      <li >
        <span  v-on:mouseover="langisnewShow = true" v-on:mouseout="langisnewShow = false">{{ langVal }}</span>
          <ul class="sRegisterBoxonUl" v-show="langisnewShow" v-on:mouseover="langisnewShow = true" v-on:mouseout="langisnewShow = false">
            <li class="sonli2" :style="{ 'color': indexLang === 0?'#ffcc53':'#9b9b9e' }" @click="goen('zh', 0, 'CN','cn','zh-CN')">CN</li>
            <li class="sonli2" :style="{ 'color': indexLang === 1?'#ffcc53':'#9b9b9e' }" @click="goen('zhf', 1,'CN(TW)','big5','zh-HK')">CN(TW)</li>
            <li class="sonli2" :style="{ 'color': indexLang === 2?'#ffcc53':'#9b9b9e' }" @click="goen('en-US',2,'EN','en','en-US')">EN</li>
            <li class="sonli2" :style="{ 'color': indexLang === 3?'#ffcc53':'#9b9b9e' }" @click="goen('ri', 3, 'JP','ja','ja-JP')">JP</li>
            <li class="sonli2" :style="{ 'color': indexLang === 4?'#ffcc53':'#9b9b9e' }" @click="goen('kn', 4, 'KOR','ko-kr','ko-KR')">KOR</li>
          </ul>
      </li>
    </ul>
    <!-- <div class="menuBox" v-show="isnewShow" v-on:mouseover="isnewShow = true" v-on:mouseout="isnewShow = false">
    </div> -->
    <!-- <ul class="menu">
      <li class="li" v-on:mouseover="isabShow = !isabShow" v-on:mouseout="isabShow = !isabShow">
        {{$t('m.about')}}
        <transition name = "fade">
          <ul class="sonUl" v-show="isabShow">
            <li class="sonli" @click="hrefGoods('institutions')">{{$t('m.Cooperationsupport')}}</li>
            <li class="sonli" @click="hrefGoods('partners')">{{$t('m.Partners')}}</li>
            <li class="sonli" @click="hrefGoods('situation')">{{$t('m.CompanyOverview')}}</li>
            <li class="sonli" @click="hrefGoods('legalDocument',1)">{{$t('m.Legaldocument')}}</li>

          </ul>
        </transition>
      </li>
      <li class="li" v-on:mouseover="isShow = !isShow" v-on:mouseout="isShow = !isShow" >
        {{$t('m.Instruments')}}
        <transition name = "fade">
          <ul class="sonUl" v-show="isShow">
            
            <li class="sonli" @click="hrefGoods('shareOption')">{{$t('m.Options')}}</li>
          </ul>
        </transition>
      </li>

      <li class="li"  v-on:mouseover="istrShow = !istrShow" v-on:mouseout="istrShow = !istrShow">
        {{$t('m.Platform')}}
        <transition name = "fade">
          <ul class="sonUl" v-show="istrShow">
            <li class="sonli" @click="gotds">{{$t('m.LoginTrade')}}</li>
            <li class="sonli" @click="hrefGoods('tradingPlatform')">{{$t('m.Platformintroduced')}}</li>
            <li class="sonli" @click="hrefGoods('download')">{{$t('m.DownloadCenter')}}</li>
          </ul>
        </transition>
      </li>
      <li class="li" :class="{'activeLi':isActive}" @click="hreftradingp">
        {{$t('m.Support')}}
      </li>
      <li class="li" v-on:mouseover="isnewShow = !isnewShow" v-on:mouseout="isnewShow = !isnewShow">
        {{$t('m.News')}}
        <transition name = "fade">
          <ul class="sonUl" v-show="isnewShow">
            <li class="sonli" @click="hrefGoods('news',1)">{{$t('m.Announcement')}}</li>
            <li class="sonli" @click="hrefGoods('news',2)">{{$t('m.IndustryNews')}}</li>
            <li class="sonli" @click="hrefGoods('news',3)">{{$t('m.EconomicCalendar')}}</li>
            <li class="sonli" @click="hrefGoods('news',4)">{{$t('m.FinancialNews')}}</li>
          </ul>
        </transition>
      </li>

    </ul> -->
    <!-- <div class="langc">
      <el-dropdown>
        <span class="el-dropdown-link cursor-pointer" >
          <svg v-if="localevl === 'zh' || localevl === 'zhf'" t="1572227765275" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3420" width="32" height="32"><path d="M0 160h1024v704H0z" fill="#F1361D" p-id="3421"></path><path d="M579.84 418.56l-27.52 32.64 1.28-42.88-39.68-16 40.96-12.16 3.2-42.88 24.32 35.84 41.6-10.24-26.24 33.92 22.4 36.48-40.32-14.72zM473.6 296.96l-42.24 6.4 29.44-31.36-19.2-38.4 39.04 17.92 30.72-30.08-5.12 42.88 38.4 19.84-42.24 8.32-7.04 42.24-21.76-37.76z m17.28 391.68l-26.24 33.92v-42.88l-40.32-14.72 40.96-13.44 1.92-42.88 25.6 34.56 41.6-11.52-26.24 33.92 23.68 35.84-40.96-12.8zM569.6 568.96l-39.04 17.92 19.2-38.4-29.44-31.36 42.24 6.4 21.12-37.76 7.04 42.24 42.24 8.32L595.2 556.8l5.12 42.88-30.72-30.72z m-296.32-30.72L166.4 615.04l39.68-125.44-106.24-78.72 131.84-1.28 41.6-124.8L315.52 409.6l131.84 1.28-106.24 78.08L380.8 614.4 273.28 538.24z" fill="#FFDC42" p-id="3422"></path></svg>
          <svg v-if="localevl === 'en-US'" t="1602665278950"  class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2187" width="32" height="32"><path d="M20.945 144.29h975.128v651.637H20.945z" fill="#FFFFFF" p-id="2188"></path><path d="M998.4 795.927H20.945V144.291h975.128v651.636z m-975.127 0h972.8V144.291h-972.8v651.636z" fill="#EFEFEF" p-id="2189"></path><path d="M20.945 144.29h975.128v55.855H20.945z m0 104.728h975.128v46.546H20.945z m0 100.073h975.128v46.545H20.945z m0 100.073h975.128v46.545H20.945z m0 100.072h975.128v46.546H20.945z m0 100.073h975.128v46.546H20.945z m0 100.073h975.128v46.545H20.945z" fill="#B72343" p-id="2190"></path><path d="M20.945 144.29h390.982v351.42H20.945z" fill="#00467B" p-id="2191"></path><path d="M90.764 202.473l2.327 6.982h6.982l-4.655 2.327 2.327 6.982-6.981-4.655-4.655 4.655 2.327-6.982-6.981-2.327h6.981z m65.163 0v6.982h6.982l-4.654 2.327 2.327 6.982-4.655-4.655-6.982 4.655 2.328-6.982-4.655-2.327h6.982z m65.164 0l2.327 6.982h6.982l-6.982 2.327 2.327 6.982-4.654-4.655-6.982 4.655 2.327-6.982-4.654-2.327h6.982z m62.836 0l2.328 6.982h6.981l-4.654 2.327 2.327 6.982-6.982-4.655-4.654 4.655 2.327-6.982-4.655-2.327h6.982z m67.491 0l2.327 6.982h6.982l-6.982 2.327 2.328 6.982-4.655-4.655-6.982 4.655 2.328-6.982-4.655-2.327h6.982z m-293.236-34.91l2.327 6.982h6.982l-6.982 4.655 2.327 6.982-4.654-4.655-4.655 4.655V179.2l-4.654-4.655h6.982z m65.163 0l2.328 6.982h4.654l-4.654 4.655 2.327 6.982-4.655-4.655-6.981 4.655 2.327-6.982-4.655-4.655h6.982z m65.164 0l2.327 6.982h6.982l-6.982 4.655 2.328 6.982-4.655-4.655-6.982 4.655 2.328-6.982-4.655-4.655h6.982z m65.164 0v6.982h6.982L256 179.2l2.327 6.982-4.654-4.655-6.982 4.655 2.327-6.982-4.654-4.655h6.981z m65.163 0l2.328 6.982h6.981l-6.981 4.655 2.327 6.982-4.655-4.655-4.654 4.655V179.2l-4.655-4.655h6.982z m65.164 0l2.327 6.982h4.655l-4.655 4.655 2.328 6.982-4.655-4.655-6.982 4.655 2.327-6.982-4.654-4.655h6.982zM90.764 274.618l2.327 4.655h6.982l-4.655 4.654 2.327 6.982-6.981-4.654-4.655 4.654 2.327-6.982-6.981-4.654h6.981z m65.163 0v4.655h6.982l-4.654 4.654 2.327 6.982-4.655-4.654-6.982 4.654 2.328-6.982-4.655-4.654h6.982z m65.164 0l2.327 4.655h6.982l-6.982 4.654 2.327 6.982-4.654-4.654-6.982 4.654 2.327-6.982-4.654-4.654h6.982z m62.836 0l2.328 4.655h6.981l-4.654 4.654 2.327 6.982-6.982-4.654-4.654 4.654 2.327-6.982-4.655-4.654h6.982z m67.491 0l2.327 4.655h6.982l-6.982 4.654 2.328 6.982-4.655-4.654-6.982 4.654 2.328-6.982-4.655-4.654h6.982zM58.182 239.71l2.327 6.98h6.982l-6.982 4.655 2.327 6.982-4.654-4.654-4.655 4.654v-6.982l-4.654-4.654h6.982z m65.163 0l2.328 6.98h4.654l-4.654 4.655 2.327 6.982-4.655-4.654-6.981 4.654 2.327-6.982-4.655-4.654h6.982z m65.164 0l2.327 6.98h6.982l-6.982 4.655 2.328 6.982-4.655-4.654-6.982 4.654 2.328-6.982-4.655-4.654h6.982z m65.164 0v6.98h6.982L256 251.346l2.327 6.982-4.654-4.654-6.982 4.654 2.327-6.982-4.654-4.654h6.981z m65.163 0l2.328 6.98h6.981l-6.981 4.655 2.327 6.982-4.655-4.654-4.654 4.654v-6.982l-4.655-4.654h6.982z m65.164 0l2.327 6.98h4.655l-4.655 4.655 2.328 6.982-4.655-4.654-6.982 4.654 2.327-6.982-4.654-4.654h6.982zM90.764 346.764l2.327 6.981h6.982l-4.655 4.655 2.327 6.982-6.981-4.655-4.655 4.655 2.327-6.982-6.981-4.655h6.981z m65.163 0v6.981h6.982l-4.654 4.655 2.327 6.982-4.655-4.655-6.982 4.655 2.328-6.982-4.655-4.655h6.982z m65.164 0l2.327 6.981h6.982l-6.982 4.655 2.327 6.982-4.654-4.655-6.982 4.655 2.327-6.982-4.654-4.655h6.982z m62.836 0l2.328 6.981h6.981l-4.654 4.655 2.327 6.982-6.982-4.655-4.654 4.655 2.327-6.982-4.655-4.655h6.982z m67.491 0l2.327 6.981h6.982l-6.982 4.655 2.328 6.982-4.655-4.655-6.982 4.655 2.328-6.982-4.655-4.655h6.982zM58.182 314.182l2.327 6.982h6.982l-6.982 2.327 2.327 6.982-4.654-2.328-4.655 2.328v-6.982l-4.654-2.327h6.982z m65.163 0l2.328 6.982h4.654l-4.654 2.327 2.327 6.982-4.655-2.328-6.981 2.328 2.327-6.982-4.655-2.327h6.982z m65.164 0l2.327 6.982h6.982l-6.982 2.327 2.328 6.982-4.655-2.328-6.982 2.328 2.328-6.982-4.655-2.327h6.982z m65.164 0v6.982h6.982L256 323.49l2.327 6.982-4.654-2.328-6.982 2.328 2.327-6.982-4.654-2.327h6.981z m65.163 0l2.328 6.982h6.981l-6.981 2.327 2.327 6.982-4.655-2.328-4.654 2.328v-6.982l-4.655-2.327h6.982z m65.164 0l2.327 6.982h4.655l-4.655 2.327 2.328 6.982-4.655-2.328-6.982 2.328 2.327-6.982-4.654-2.327h6.982zM90.764 421.236l2.327 6.982h6.982l-4.655 4.655 2.327 4.654-6.981-2.327-4.655 2.327 2.327-4.654-6.981-4.655h6.981z m65.163 0v6.982h6.982l-4.654 4.655 2.327 4.654-4.655-2.327-6.982 2.327 2.328-4.654-4.655-4.655h6.982z m65.164 0l2.327 6.982h6.982l-6.982 4.655 2.327 4.654-4.654-2.327-6.982 2.327 2.327-4.654-4.654-4.655h6.982z m62.836 0l2.328 6.982h6.981l-4.654 4.655 2.327 4.654-6.982-2.327-4.654 2.327 2.327-4.654-4.655-4.655h6.982z m67.491 0l2.327 6.982h6.982l-6.982 4.655 2.328 4.654-4.655-2.327-6.982 2.327 2.328-4.654-4.655-4.655h6.982zM58.182 388.655l2.327 4.654h6.982l-6.982 4.655 2.327 6.981-4.654-4.654-4.655 4.654v-6.981l-4.654-4.655h6.982z m65.163 0l2.328 4.654h4.654l-4.654 4.655 2.327 6.981-4.655-4.654-6.981 4.654 2.327-6.981-4.655-4.655h6.982z m65.164 0l2.327 4.654h6.982l-6.982 4.655 2.328 6.981-4.655-4.654-6.982 4.654 2.328-6.981-4.655-4.655h6.982z m65.164 0v4.654h6.982L256 397.964l2.327 6.981-4.654-4.654-6.982 4.654 2.327-6.981-4.654-4.655h6.981z m65.163 0l2.328 4.654h6.981l-6.981 4.655 2.327 6.981-4.655-4.654-4.654 4.654v-6.981l-4.655-4.655h6.982z m65.164 0l2.327 4.654h4.655l-4.655 4.655 2.328 6.981-4.655-4.654-6.982 4.654 2.327-6.981-4.654-4.655h6.982zM58.182 456.145l2.327 6.982h6.982l-6.982 4.655 2.327 6.982-4.654-4.655-4.655 4.655v-6.982l-4.654-4.655h6.982z m65.163 0l2.328 6.982h4.654l-4.654 4.655 2.327 6.982-4.655-4.655-6.981 4.655 2.327-6.982-4.655-4.655h6.982z m65.164 0l2.327 6.982h6.982l-6.982 4.655 2.328 6.982-4.655-4.655-6.982 4.655 2.328-6.982-4.655-4.655h6.982z m65.164 0v6.982h6.982L256 467.782l2.327 6.982-4.654-4.655-6.982 4.655 2.327-6.982-4.654-4.655h6.981z m65.163 0l2.328 6.982h6.981l-6.981 4.655 2.327 6.982-4.655-4.655-4.654 4.655v-6.982l-4.655-4.655h6.982z m65.164 0l2.327 6.982h4.655l-4.655 4.655 2.328 6.982-4.655-4.655-6.982 4.655 2.327-6.982-4.654-4.655h6.982z" fill="#FFFFFF" p-id="2192"></path></svg>
          <svg t="1602665711154" class="icon" v-if="localevl === 'ri'" viewBox="0 0 1544 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3102" width="32" height="32"><path d="M10.04 1016.47h1517.176V7.53H10.039v1008.94z m1519.685 3.765v-3.764 3.764zM3.765 1024V1.255H1533.49v1021.49H3.765z" fill="#353636" p-id="3103"></path><path d="M6.275 5.02h1523.45v1015.215H6.275z" fill="#FFFFFF" p-id="3104"></path><path d="M463.059 512a304.941 304.941 0 1 0 609.882 0 304.941 304.941 0 1 0-609.882 0z" fill="#C01D3C" p-id="3105"></path></svg>
          <svg t="1602666492384" class="icon" viewBox="0 0 1543 1024" version="1.1" v-if="localevl === 'kn'"  xmlns="http://www.w3.org/2000/svg" p-id="3952" width="32" height="32"><path d="M8.784314 1017.72549h1517.17647V8.784314H8.784314v1008.941176z m1519.686274 2.509804V1016.470588v3.764706zM2.509804 1024V1.254902h1529.72549v1021.490196H2.509804z" fill="#353636" p-id="3953"></path><path d="M6.27451 5.019608h1523.45098v1015.215686H6.27451z" fill="#FFFFFF" p-id="3954"></path><path d="M1016.470588 489.411765c12.54902 138.039216-89.098039 259.764706-227.137255 272.313725-138.039216 12.54902-259.764706-89.098039-272.313725-227.137255-12.54902-138.039216 89.098039-259.764706 227.137255-272.313725C882.196078 250.980392 1003.921569 352.627451 1016.470588 489.411765z" fill="#CC303C" p-id="3955"></path><path d="M553.411765 382.745098c-36.392157 58.980392-17.568627 135.529412 42.666666 171.921569 58.980392 36.392157 135.529412 16.313725 171.921569-42.666667 36.392157-58.980392 112.941176-77.803922 171.921569-42.666667 58.980392 36.392157 77.803922 112.941176 42.666666 171.921569-71.529412 117.960784-225.882353 155.607843-343.843137 84.078431-119.215686-70.27451-156.862745-223.372549-85.333333-342.588235z" fill="#005C9E" p-id="3956"></path><path d="M235.13098 310.939608L375.466667 102.876863l32.25098 21.76-140.348235 208.062745zM285.339608 344.696471L425.738039 136.658824l32.250981 21.76-140.398432 208.037647zM335.058824 378.980392l32.627451 21.333333 140.549019-208.313725-32.627451-22.588235zM1101.741176 720.589804L1167.058824 623.861961l32.238431 21.772549-65.305098 96.727843zM1026.534902 834.007843l65.204706-96.790588 32.263529 21.734902-65.204706 96.790588zM1151.184314 755.338039l65.355294-96.690196 32.225882 21.785098-65.355294 96.690196zM1076.705882 867.137255l32.627451 21.333333 65.254902-96.627451-32.627451-21.333333zM1201.53098 789.157647l65.204706-96.790588 32.26353 21.734902-65.204706 96.790588zM1126.111373 900.856471l65.054117-96.890981 32.301177 21.684706-65.066667 96.89098zM1217.254902 366.431373l32.627451-21.333334-140.54902-208.313725-32.627451 21.333333zM1126.312157 123.971765l32.25098-21.785098 65.317647 96.715294-32.238431 21.772549zM1202.17098 236.900392l32.225883-21.797647 65.380392 96.665098-32.213333 21.797647zM1026.095686 191.824314l32.276079-21.709804 65.15451 96.828235-32.288628 21.709804zM1101.276863 303.573333l32.25098-21.734902 65.229804 96.77804-32.263529 21.747451zM334.343529 646.500392l32.238432-21.772549 140.498823 207.987451-32.25098 21.772549zM235.218824 713.512157l32.25098-21.734902 140.260392 208.138039-32.263529 21.734902zM284.875294 681.173333l32.250981-21.747451 65.254901 96.77804-32.263529 21.747451zM425.411765 888.470588l32.627451-21.333333-65.254902-96.627451-32.627451 21.333333z" fill="#231815" p-id="3957"></path></svg>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="goen('en-US')">English</el-dropdown-item>
          <el-dropdown-item @click.native="goen('zh')">中文</el-dropdown-item>
          <el-dropdown-item @click.native="goen('zhf')">中文繁体</el-dropdown-item>
          <el-dropdown-item @click.native="goen('kn')">한국어</el-dropdown-item>
          <el-dropdown-item @click.native="goen('ri')">日本語</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div> -->
    <!-- <div class="lg-box">
      <template v-if="isLogin">
        <img src="../assets/images/20191125170908.png" alt="" width="30" height="30"/>
        <span>{{loginphone}}</span>
      </template>
      <template>
        <span @click="gotd" style="margin-right:30px">{{$t('m.Login')}}</span>
        <span class="ver-line">|</span>
        <span @click="registered">{{$t('m.Register')}}</span>
      </template>

    </div> -->
    <!-- <loginPage :openFlag="openFlag" @childFn="parentFn" v-if="openFlag"/> -->
  </div>
</template>

<script>
import BaseConfig from '@/common/baseConfig';
import methods from '@/common/methods';
import loginPage from '@/components/loginPage';
import { Message } from 'element-ui';
import Bus from "@/common/Bus"
export default {
  name: 'headPage',
  components: {
    loginPage,
  },
  
  data () {
    return {
      indexLang: 0,
      indexVal: null,
      bigindexVal: null,
      langisnewShow: false,
      otcMenu: false,
      istrainingShow: false,
      isLogin: false,
      isOrderActive: false,
      openFlag: false,
      isabShow: false,
      istrShow: false,
      isShow: false,
      isnewShow: false,
      isnewShow2: false,
      isnewShow3: false,
      isnewShow4: false,
      isnewShow5: false,
      isnewShow6: false,
      isActive: false,
      activeIndex: '',
      localevl: 'zh',
      langVal: 'CN',
      kefuval: 'cn',
      dsflangval: 'zh-CN',
      loginphone: 122222222222,
      innerHeight: 0,
      innerHeight2: 0,
    }
  },
  
  mounted () {
      this.innerHeight = window.innerHeight -84
      this.innerHeight2 = window.innerHeight -44

      Bus.$on('indexVal', val => {
        this.indexVal = val
      })
      Bus.$on('bigindexVal', val => {
        this.bigindexVal = val
      })
      this.$cookie.set('language', 'zh', 1);
      // const payload = localStorage.getItem('payload');
      // if(payload !== '' &&  payload !== null) {
      //     const newpayload = JSON.parse(payload);
      //     this.loginphone = newpayload.phone.replace(/^(\d{3})\d{4}(\d+)/,"$1****$2");
      //     this.isLogin = true
      //     this.openFlag = newpayload.flag;      
      // }else {
      //   this.openFlag = false
      //    localStorage.setItem('payload', '');
      // }
      // this.localevl = 'en'
      // this.$i18n.locale = 'en';
      // Bus.$emit("lang", 'en')
      // localStorage.setItem('currlocale', 'en')

    // goen('zh', 0, 'CN','cn','zh-CN')
    // goen('zhf', 1,'CN(TW)','big5','zh-HK')
    // goen('en-US',2,'EN','en','en-US')
    // goen('ri', 3, 'JP','ja','ja-JP')
    // goen('kn', 4, 'KOR','ko-kr','ko-KR')
      const url = window.location.href
      if(url.indexOf('?')!== -1){
        const lang = (url.substring(url.indexOf('=') + 1))
        if(lang === 'ja-JP'){
          this.goen('ri', 3, 'JP','ja','ja-JP')
        }else if(lang === 'zh-HK'){
          this.goen('zhf', 1,'CN(TW)','big5','zh-HK')
        }else if(lang === 'ko-KR'){
          this.goen('kn', 4, 'KOR','ko-kr','ko-KR')
        }else if(lang === 'en-US'){
          this.goen('en-US',2,'EN','en','en-US')
        }else{
          this.goen('zh', 0, 'CN','cn','zh-CN')
        }
      }
      localStorage.setItem('dsflangval', this.dsflangval)
      document.addEventListener('scroll', function() {
      var header = document.getElementById('header');
      var scrollPosition = window.scrollY || document.documentElement.scrollTop; // 获取滚动位置
      if(scrollPosition>78){
        header.style.backgroundColor = `rgba(0, 0, 0, 1)`
      }
      if(scrollPosition === 0){
        header.style.backgroundColor = `rgba(0, 0, 0, 1)`
      }


});
  },
  methods: {
    signinhrefwai () {
      window.open('https://desktop.bp-markets.com/exchange.2x/signin?language=' + this.dsflangval);
    },
    signuphrefwai () {
      
      window.open('https://desktop.bp-markets.com/exchange.2x/signup?language=' + this.dsflangval);
    },
    hrefwai () {
      window.open('https://www.plcgx.com/otc/#/index');
    },
    kefuhrefwai () {
      window.open('https://www.bp-markets.com/echat/chatlink?lng=' + this.kefuval);
    },
    sfsfft () {
      window.open('https://t.me/bp_markets_support');
    },
    parentFn(payload) {
      if(payload.hasOwnProperty('phone')){
        this.loginphone = payload.phone.replace(/^(\d{3})\d{4}(\d+)/,"$1****$2");
        this.isLogin = true
        this.openFlag = payload.flag;
        localStorage.setItem('payload', JSON.stringify(payload));
      }else {
        this.openFlag = payload
      }
    },
    goen(val, index, lang,kefuval, dsflangval){
      localStorage.setItem('dsflangval', dsflangval)
      this.dsflangval = dsflangval
      this.kefuval = kefuval
      this.langVal = lang
      this.indexLang = index
      this.localevl = val
      this.$i18n.locale = val;
      Bus.$emit("lang", val)
      Bus.$emit("lang2", dsflangval)
      localStorage.setItem('currlocale', val)
    },
    hrefGoods (href,pageindex,index) {
      this.indexVal = index
      this.isnewShow = false
      if(index === 1 || index === 2 || index === 3 || index === 4){
        this.bigindexVal = 1
      }
      if(index === 5 || index === 6 || index === 7 || index === 8 || index === 9){
        this.bigindexVal = 2
      }
      if(index === 11 ){
        this.bigindexVal = 4
      }
      if(index === 16 || index === 14 || index === 15){
        this.bigindexVal = 6
      }
      if(index === 12 || index === 13 ){
        this.bigindexVal = 5
      }
      if(index === 10 ){
        this.bigindexVal = 3
      }
      this.$router.push({
        name: href,
        params: {
          label: pageindex
        }
      })
    },
    hrefb (href) {
      // this.$router.push({path:'/'+href});
      this.activeIndex = 1;
    },
    gotd(){
      window.open(BaseConfig.LOGIN_URL);
      // this.openFlag = true;
    },
    gotds(){
      window.open(BaseConfig.LOGIN_URL);
    },
    registered() {
        window.open(BaseConfig.REGIST_URL);
    },
    hreftradingp() {
        this.hrefGoods('training');
        this.isActive = true;
    },
    hreforder() {
        this.hrefGoods('otcOrder');
        this.isOrderActive = true;
    },
    hrefBef(url) {
      const payload = localStorage.getItem('payload');
      console.log(payload);
      if(payload !== '') {
        this.hrefGoods(url);
      }else {
        Message.error('请先登录');
      }
    }
  }
}
</script>
<style lang="stylus">
  .el-dropdown{
    height:50px
  }
</style>
<style  lang="stylus" scoped>
  @import "~common/stylus/headPage.styl";
</style>



// WEBPACK FOOTER //
// src/components/headPage.vue